<template>
  <article class="layout-section -bg-shade-light">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">Projets terminés</h2>
    </div>

    <section class="layout-section__index">
      <div v-for="entry in projects" :key="entry.slug" class="card -bigger">
        <h4 v-if="entry.intro.date" class="card__uptitle">
          <SvgIcon id="content-date" />
          {{ entry.intro.date }}
        </h4>
        <h3 class="card__title">{{ entry.shortTitle || entry.title }}</h3>

        <p v-if="entry.intro.text">
          {{ entry.intro.text }}
        </p>

        <RouterLink
          v-if="entry.content"
          :to="{
            name: 'project-single',
            params: { projectSlug: entry.slug }
          }"
          class="link card__cta"
        >
          En savoir plus
          <SvgIcon id="action-arrow" />
        </RouterLink>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'ProjectsIndex',
  computed: {
    projects() {
      return Object.values(this.$wp.projects).filter(({ isDone }) => isDone)
    }
  }
}
</script>
